import AraleQRCode from 'arale-qrcode';
//创建不重复的全局唯一标识符guid
export function createGuid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

export function creatqrcode(text = '', logo = '') {
    // 生成二维码
    var codeFigure = new AraleQRCode({
        render: 'svg', // 生成的类型 'svg' or 'table'
        text: text, // 需要生成二维码的链接
        size: 200, // 生成二维码大小
        foreground: '#000000', // 二维码颜色
        image: logo, // 二维码中间logo
        imageSize: 50 // 二维码中间logo大小
    });
    const svgXml = new XMLSerializer().serializeToString(codeFigure);
    const src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(svgXml)));
    return src;
}